__turbopack_context__.v({
  "navbar_desktop": "Navbar-module-scss-module__oMRrWW__navbar_desktop",
  "navbar_mobile": "Navbar-module-scss-module__oMRrWW__navbar_mobile",
});
